import { __awaiter } from "tslib";
import { getFirstPartyAppDefinition, isCopilotEnabled, isFirstPartyApp, } from './api/fetchPreinstalledApps';
import { loadAppDefinitionWithAppId, reloadAppDefinitions, } from './loadAppDefinitions';
import { searchAppDefinitions, setupM365AppsConfigService } from './utils';
export const findAppDefinitionById = (appId, isEligibleForAnyCopilot, locStrings, isBCAISContext) => __awaiter(void 0, void 0, void 0, function* () {
    if (!appId) {
        return undefined;
    }
    const isCopilotEnabledValue = isEligibleForAnyCopilot || (yield isCopilotEnabled());
    if (isFirstPartyApp(appId) && isCopilotEnabledValue) {
        const appDefinition = yield getFirstPartyAppDefinition(appId, locStrings, isBCAISContext, isEligibleForAnyCopilot);
        if (appDefinition) {
            return appDefinition;
        }
    }
    //This is to check the appManifest from mos3 api
    yield setupM365AppsConfigService();
    let appDefinition = searchAppDefinitions(appId);
    if (appDefinition) {
        return appDefinition;
    }
    //fallback api call with specific appId
    yield loadAppDefinitionWithAppId(appId);
    appDefinition = searchAppDefinitions(appId);
    if (appDefinition) {
        return appDefinition;
    }
    //fallback api call with all apps
    yield reloadAppDefinitions();
    return searchAppDefinitions(appId);
});
//# sourceMappingURL=findAppDefinitionById.js.map